import { PayloadAction, ThunkAction } from "@reduxjs/toolkit";
import { RootState } from "@/store";
import searchFilterSlice from "./searchFilterSlice";
import { ICatalogueSearchFilter } from "@/shared/dtos/catalogue-search-filter-dto.ts";

export const searchFilterActions = searchFilterSlice.actions;

export const setSearchFilter = (
	searchFilter: Partial<ICatalogueSearchFilter>,
): ThunkAction<
	void,
	RootState,
	unknown,
	PayloadAction<Partial<ICatalogueSearchFilter>>
> => {
	return async (dispatch) => {
		dispatch(searchFilterActions.setSearchFilter(searchFilter));
	};
};

export const resetSearchFilter = (): ThunkAction<
	void,
	RootState,
	unknown,
	PayloadAction<void>
> => {
	return async (dispatch) => {
		dispatch(searchFilterActions.resetSearchFilter());
	};
};

export const updateAccessRightValue = (
	value: string[],
): ThunkAction<void, RootState, unknown, PayloadAction<string[]>> => {
	return async (dispatch) => {
		dispatch(searchFilterActions.updateAccessRightValue(value));
	};
};
